var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50002 10.6481C1.50229 10.965 1.60641 11.2728 1.797 11.526C1.98759 11.7793 2.25454 11.9645 2.55846 12.0544L9.73596 14.2631L11.9447 21.4406C12.0347 21.7445 12.22 22.0113 12.4732 22.2019C12.7264 22.3925 13.0341 22.4966 13.351 22.4991H13.3791C13.6898 22.502 13.9936 22.4069 14.2472 22.2273C14.5008 22.0477 14.6914 21.7928 14.7919 21.4987L20.9063 5.00718C20.9083 5.00232 20.9098 4.9973 20.911 4.99218C21.0024 4.72671 21.0174 4.44091 20.9544 4.16731C20.8914 3.8937 20.7529 3.64327 20.5546 3.44449C20.3564 3.24572 20.1063 3.10658 19.8328 3.04292C19.5594 2.97925 19.2735 2.99361 19.0078 3.08436L18.9928 3.08905L2.50034 9.20718C2.20171 9.30925 1.94355 9.50415 1.76358 9.7634C1.58361 10.0226 1.49126 10.3326 1.50002 10.6481Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.21de381fdf66133d997d7cae34986689.svg";
export { ForwardRef as ReactComponent };